import React from "react";
import s from "./index.module.scss";
import { Heading } from "@masonite/external-ui-react";
import Swatches from "components/forms/Swatches";

const OptionalComponents = ({
    product,
    options,
    containerState,
    setContainerState
}) => {

    const Section = ({ children }) => (
        <section className={s.section}>{children}</section>
    );

    const borderRadius = 0;

    return (
        <Section>
            <Heading level="2">
                {"Optional Components"}
            </Heading>
            <Swatches
                values={options.optional_component.map(optional_component => ({
                    label: optional_component.name,
                    value: optional_component.hash,
                    color: "#ccc",
                    image: optional_component.image_url
                }))}
                borderRadius={borderRadius}
                selectedSwatch={null}
                swatchSize={containerState.swatchSize}
                tooltipBgSize = "contain"
                selectHandler={() => {}}
                showLabels
                showTooltip
                handleTooltipClick={hash =>
                    containerState.showTooltipFor === hash
                        ? setContainerState("showTooltipFor")(
                            null
                        )
                        : setContainerState("showTooltipFor")(
                            hash
                        )
                }
                showTooltipFor={containerState.showTooltipFor}
            />
        </Section>
    );
};

export default OptionalComponents;